import NewHome from "./Home/NewHome";
import NewLogoCarousel from "./LogoCarousel/NewLogoCarousel";
import NewFeatureSection from "./NewFeatureSection";
import ReviewBoostSection from "./ReviewBoostSection";
import CustomerResultsSection from "./CustomerResultsSection";
import AllFeatures from "./AllFeatures";
import AnalyzeAndGrow from "./AnalyzeAndGrow";
import FeaturesGrid from "./FeaturesGrid";
import BenefitsOfZola from "./BenefitsOfZola";
import TestimonialsSection from "./TestimonialsSection";
import FAQSection from "./FAQSection";
import ContactCTASection from "./ContactCTASection";
import Features from "./HomePage/components/Features";

function Homepage() {
  return (
    <div className="grid grid-cols-1 gap-4">
      <NewHome />
      <NewLogoCarousel />
      <Features />
      {/* <InfoSection /> */}
      <NewFeatureSection />
      <ReviewBoostSection />
      <CustomerResultsSection />
      <AllFeatures />      
      <AnalyzeAndGrow />
      <FeaturesGrid />
      <BenefitsOfZola />
      <TestimonialsSection />
      <FAQSection />
      <ContactCTASection />
      {/* <Home />
      <LogoCarousel />
      <HowItWorks />
      <CustomerResults />

      <KeyBenefits />
      <Performance />
      <GetReviews />
      <ClearlyTrack />

      <Testimonial />
      <Ready />
      <Chatbot /> */}
    </div>
  );
}

export default Homepage;
